import { __ } from '@wordpress/i18n';
import {MediaPlaceholder, MediaUpload, MediaUploadCheck} from '@wordpress/block-editor';
import { useState, useEffect } from '@wordpress/element';
import { Button ,  FocalPointPicker,  __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,ToggleControl} from '@wordpress/components';
const ALLOWED_MEDIA_TYPES = ['image'];

export const VayuBlocksMedia = ({ onChange, background }) => {
    const { value, backgroundKey } = background;
    const hasImage = value?.image?.url;

    const [focalPoint, setFocalPoint] = useState(value?.image?.focalPoint || { x: 0.5, y: 0.5 });
    const [attachment, setAttachment] = useState(value?.image?.attachment || 'scroll');
    const [repeat, setRepeat] = useState(value?.image?.repeat || 'repeat');
    const [size, setSize] = useState(value?.image?.size || 'cover');

    useEffect(() => {
        if (value?.image?.focalPoint) {
            setFocalPoint(value.image.focalPoint);
        }
    }, [value?.image?.focalPoint]);

    const updateImageValue = (updatedFields) => {
        const updatedValue = {
            ...value,
            image: {
                ...value.image,
                ...updatedFields,
            },
        };
        onChange(backgroundKey, updatedValue);
    };

    const handleSelect = (media) => {
        const updatedValue = {
            ...value,
            image: {
                url: media.url,
                id: media.id,
                alt: media.alt || '',
                focalPoint: focalPoint,
            },
        };
        onChange(backgroundKey, updatedValue);
    };

    const handleRemove = () => {
        const updatedValue = {
            ...value,
            image: {
                url: '',
                id: null,
                alt: '',
                focalPoint: { x: 0.5, y: 0.5 },
            },
        };
        onChange(backgroundKey, updatedValue);
        setFocalPoint({ x: 0.5, y: 0.5 });
    };

    const handleFocalPointChange = (point) => {
        setFocalPoint(point);
        updateImageValue({ focalPoint: point });
    };

    const handleSettingChange = (key, val) => {
        if (key === 'attachment') setAttachment(val);
        if (key === 'repeat') setRepeat(val);
        if (key === 'size') setSize(val);
        updateImageValue({ [key]: val });
    };

    const resetAll = () => {
        handleSettingChange('attachment', undefined);
        handleSettingChange('repeat', undefined);
        handleSettingChange('size', undefined);
     };

    return (
            <MediaUploadCheck>
                {hasImage ? (
                                
                    <div className="vb-media-preview-wrapper">
                    <ToolsPanel label={ __('Image', 'vayu-blocks')} resetAll={resetAll} >

                        <ToolsPanelItem
                            hasValue={ () => !! focalPoint }
                            label={__('Focal Point', 'vayu_blocks')}
                            isShownByDefault
                            onDeselect={()=>handleFocalPointChange(undefined)}
                        >
                            
                            <FocalPointPicker
                                value={focalPoint}
                                onChange={handleFocalPointChange}
                                url={value.image.url}
                                __nextHasNoMarginBottom
                            />

                        </ToolsPanelItem>

                        <ToolsPanelItem
                            hasValue={ () => !attachment }
                            label={__('Attachment', 'vayu_blocks')}
                            onDeselect={()=>handleSettingChange('attachment', undefined)}
                        >
                        <ToggleGroupControl
                                label={__('Attachment', 'vayu-blocks')}
                                value={attachment}
                                isBlock
                                onChange={(val) => handleSettingChange('attachment', val)}
                                __next40pxDefaultSize
                                __nextHasNoMarginBottom
                                className='vayu-blocks-background-settings'
                            >
                                <ToggleGroupControlOption value="scroll" label="Scroll" />
                                <ToggleGroupControlOption value="fixed" label="Fixed" />
                                <ToggleGroupControlOption value="local" label="Local" />
                            </ToggleGroupControl>
                        </ToolsPanelItem>

                        <ToolsPanelItem
                            hasValue={ () => ! size }
                            label={__('Size', 'vayu_blocks')}
                            onDeselect={()=>handleSettingChange('size', undefined)}
                        >
                        <ToggleGroupControl
                                label={__('Size', 'vayu-blocks')}
                                value={size}
                                onChange={(val) => handleSettingChange('size', val)}
                                __next40pxDefaultSize
                                isBlock
                                __nextHasNoMarginBottom
                                className='vayu-blocks-background-settings'
                            >
                                <ToggleGroupControlOption value="auto" label="Auto" />
                                <ToggleGroupControlOption value="cover" label="Cover" />
                                <ToggleGroupControlOption value="contain" label="Contain" />
                            </ToggleGroupControl> 
                        </ToolsPanelItem>

                        <ToolsPanelItem
                            hasValue={ () => ! repeat }
                            label={__('Image Repeat', 'vayu_blocks')}
                            onDeselect={()=>handleSettingChange('repeat', undefined)}
                        >

                        <ToggleControl
                            __nextHasNoMarginBottom={true}
                            checked={repeat === 'repeat'}
                            label={__('Image Repeat', 'vayu-blocks')}
                            onChange={(val) => handleSettingChange('repeat', val ? 'repeat' : 'no-repeat')}
                            className='vayu-blocks-background-settings-togglecobntrol'
                        />

                        </ToolsPanelItem>

                    </ToolsPanel>

                        <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                            <MediaUpload
                                onSelect={handleSelect}
                                allowedTypes={ALLOWED_MEDIA_TYPES}
                                value={value.image.id}
                                render={({ open }) => (
                                    <Button onClick={open} isSecondary>
                                        {__('Replace Image', 'vayu-blocks')}
                                    </Button>
                                )}
                            />
                            <Button
                                onClick={handleRemove}
                                // className='vayu-blcoks-remove-image-component'
                                isLink
                                isDestructive
                            >
                                {__('Remove', 'vayu-blocks')}
                            </Button>
                        </div>
                    </div>
                ) : (
                    <MediaPlaceholder
                        icon="format-image"
                        labels={{
                            title: __('Background Image', 'vayu-blocks'),
                            name: __('an image', 'vayu-blocks'),
                        }}
                        onSelect={handleSelect}
                        onSelectURL={(url) =>
                            handleSelect({
                                url,
                                id: null,
                                alt: '',
                            })
                        }
                        accept="image/*"
                        allowedTypes={ALLOWED_MEDIA_TYPES}
                    />
                )}
            </MediaUploadCheck>
    );
};